import Styled, { createGlobalStyle } from "styled-components";
import { Container } from "reactstrap";

export default createGlobalStyle`

    .link{
        color: ${(props) => props.theme.main.mainBlue};
    }

    .btn-radio {
        color: ${(props) => props.theme.main.title};
        cursor: pointer;
        background-color: ${(props) => props.theme.main.backgroundWhite};
        border-color: ${(props) => props.theme.main.clickable};

        &:first-child {
            border-radius: 50px 0 0 50px;
        }

        &:last-child {
            border-radius: 0 50px 50px 0;
        }

        &:hover, &.active {
            background-color: ${(props) =>
        props.theme.main.backgroundRadioActive};
            color: ${(props) =>
        props.theme.main.backgroundRadioActiveText} !important;
            font-weight: bold;

            img {
                filter: grayscale(100%);
            }
        }
    }


    .right-answer{
        color: green;
        font-size: 1.8rem;
    }

    .wrong-answer{
        color: red;
        font-size: 1.8rem;
    }
`

export const ContainerFlex = Styled(Container)`
    margin-top: 2rem;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    flex-direction: column;

    @media screen and (max-width: 768px) {
        padding: 0;
        margin: 0;
    }
`;
